<ll-titulo>Categoría Editar</ll-titulo>

<grupo-recursos-edit
    [grupoRecursoTipoId]="grupoRecursoTipoId"
    [grupoRecursoTipoCategoriasString]="grupoRecursoTipoCategorias"
></grupo-recursos-edit>
